export enum MessageState {
  SUCCESS = 'success',
  NEUTRAL = 'neural',
  ERROR = 'error',
}
